import { render } from "./questionItem.vue?vue&type=template&id=65328e1e&scoped=true"
import script from "./questionItem.vue?vue&type=script&lang=js"
export * from "./questionItem.vue?vue&type=script&lang=js"

import "./questionItem.vue?vue&type=style&index=0&id=65328e1e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65328e1e"]])

export default __exports__